import { Box } from '@mui/system'
import React from 'react'
import FormList from '../components/FormList'
import EvaluationList from '../components/EvaluationList'

const AppraisalCompanyMgmt = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: { xs: 2, lg: 0 } }}>
      <EvaluationList />
      <FormList />
    </Box>
  )
}

export default AppraisalCompanyMgmt
